import { $api } from "../AxiosInstance";

export class FaqService {
  // FAQ V1
  static async getFaq() {
    return await $api.get("/api/admin/faq/all");
  }

  static async getFaqByLocale() {
    return await $api.get("/api/admin/faq/all/groupBy/locale");
  }

  static async getFaqById(id) {
    return await $api.get("/api/admin/faq", { params: { id } });
  }

  static async createFaq(showOnFront, locale, question, answer, index) {
    return await $api.put("/api/admin/faq", {
      showOnFront,
      locale,
      question,
      answer,
      index,
    });
  }

  static async saveFaq(id, showOnFront, locale, question, answer, index) {
    return await $api.post("/api/admin/faq", {
      id,
      showOnFront,
      locale,
      question,
      answer,
      index,
    });
  }

  static async deleteFaq(id) {
    return await $api.delete("/api/admin/faq", { params: { id } });
  }

  static async changeFaqOrder(faqSortedIds) {
    return await $api.post("/api/admin/faq/changeIndices", {
      faqSortedIds,
    });
  }

  // FAQ V2 Topics
  static async getFaqTopicsV2() {
    return await $api.get("/api/admin/faqType/v2/all");
  }

  static async getFaqTopicByIdV2(id) {
    return await $api.get("/api/admin/faqType/v2/byId", { params: { id } });
  }

  static async createFaqTopicV2(params) {
    return await $api.put("/api/admin/faqType/v2/create", params);
  }

  static async updateFaqTopicV2(params) {
    return await $api.post("/api/admin/faqType/v2/save", params);
  }

  static async changeOrderFaqTopicsV2(faqSortedIds) {
    return await $api.post("/api/admin/faqType/v2/changeIndices", {
      faqSortedIds,
    });
  }

  static async deleteFaqTopicV2(id) {
    return await $api.delete("/api/admin/faqType/v2/delete", { params: { id } });
  }

  // FAQ V2 Items
  static async getFaqItemsByLocaleAndTopicIdV2(params) {
    return await $api.get("/api/admin/faq/v2/by/locale/faqType", { params });
  }

  static async getFaqItemByIdV2(id) {
    return await $api.get("/api/admin/faq/v2/byId", { params: { id } });
  }

  static async createFaqItemV2(params) {
    return await $api.put("/api/admin/faq/v2/create", params);
  }

  static async updateFaqItemV2(params) {
    return await $api.post("/api/admin/faq/v2/save", params);
  }

  static async changeOrderFaqItemsV2(faqSortedIds) {
    return await $api.post("/api/admin/faq/v2/changeIndices", { faqSortedIds });
  }

  static async deleteFaqItemV2(id) {
    return await $api.delete("/api/admin/faq/v2/delete", { params: { id } });
  }

  // FAQ V3 Topics
  static async getFaqTopicsV3() {
    return await $api.get("/api/admin/faqType/v3/all");
  }

  static async getFaqTopicByIdV3(id) {
    return await $api.get("/api/admin/faqType/v3/byId", { params: { id } });
  }

  static async createFaqTopicV3(params) {
    return await $api.put("/api/admin/faqType/v3/create", params);
  }

  static async updateFaqTopicV3(params) {
    return await $api.post("/api/admin/faqType/v3/save", params);
  }

  static async changeOrderFaqTopicsV3(faqSortedIds) {
    return await $api.post("/api/admin/faqType/v3/changeIndices", {
      faqSortedIds,
    });
  }

  static async deleteFaqTopicV3(id) {
    return await $api.delete("/api/admin/faqType/v3/delete", { params: { id } });
  }

  // FAQ V3 Items
  static async getFaqItemsByLocaleAndTopicIdV3(params) {
    return await $api.get("/api/admin/faq/v3/by/locale/faqType", { params });
  }

  static async getFaqItemByIdV3(id) {
    return await $api.get("/api/admin/faq/v3/byId", { params: { id } });
  }

  static async createFaqItemV3(params) {
    return await $api.put("/api/admin/faq/v3/create", params);
  }

  static async updateFaqItemV3(params) {
    return await $api.post("/api/admin/faq/v3/save", params);
  }

  static async changeOrderFaqItemsV3(faqSortedIds) {
    return await $api.post("/api/admin/faq/v3/changeIndices", { faqSortedIds });
  }

  static async deleteFaqItemV3(id) {
    return await $api.delete("/api/admin/faq/v3/delete", { params: { id } });
  }
}
